import { render, staticRenderFns } from "./AddMerchantCompanyComponent.vue?vue&type=template&id=3350c468&"
import script from "./AddMerchantCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./AddMerchantCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports